var LayoutUI = (function() {


    var _initialize = function() {

       $('.js-accordion > label').click(function(){
           $(this).closest('.js-accordion').find('.js-accordion-content').slideToggle(500);
           $(this).closest('.js-accordion').toggleClass('open');
       })

       $('.js-scroll-to-offers').click(function(){
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#offerlist").offset().top
            }, 1000);
        })
      
    };

    return {
        init: _initialize,
    }
    
})();

// Initialize
$(window).on('load', function(){

    LayoutUI.init()

});




